import React, { useEffect, useState } from "react";
import { useAppSelector } from "@app/state";

import TreeList, {
  Column,
  SearchPanel,
  Selection,
  Scrolling,
  Editing,
  Toolbar,
  Item,
} from "devextreme-react/tree-list";

import { useWindowDimensions } from "@app/contexts";
import "@app/style/dx.generic.catetory-chooser-compact.css";

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const JGAPCommonTree = ({
  treeId,
  treeDataSelector,
  currenNodeSelector,
  cellRender,
  treeSelectionChanged,
  onAdd = noop,
  onFilter = noop,
  customAddOptions = {},
  treeData,
}: {
  treeId: string;
  treeDataSelector: (state: any) => any;
  currenNodeSelector: (state: any) => any;
  cellRender: (e: any) => JSX.Element;
  treeSelectionChanged: (e: any) => void;
  onAdd?: (e: any) => void;
  onFilter?: (e: any) => void;
  customAddOptions?: any;
  treeData?: any[];
}) => {
  const { drawerHeight } = useWindowDimensions();
  const [nodeId, setNodeId] = useState<string[]>([]);
  const [viewInactives, setViewInactives] = useState<boolean>(false);
  const selectedTreeData = useAppSelector(treeDataSelector);
  const theTreedata_ = treeData || selectedTreeData;

  const theTreedata = theTreedata_
    .filter((e: any) => {
      if (treeId !== "groupsTreeList") return true;
      if (viewInactives) return true;
      if (e?.ptlIsActive === true) return true;

      const parent = theTreedata_.find((item: any) => item.id === e?.parentId);
      return parent?.ptlIsActive === true;
    })
    .map((e: any) => ({
      ...e,
      ptlHasItems: theTreedata_.some((item: any) => item.parentId === e.id),
    }));
  const theStateNode = useAppSelector(currenNodeSelector);

  const onFilterLocal = (e: any) => {
    setViewInactives(!viewInactives);
    onFilter(e);
  };

  useEffect(() => {
    if (theStateNode?.id !== nodeId[0]) {
      setNodeId([theStateNode?.id || undefined]);
    }
  }, [theStateNode?.id]);

  return (
    <TreeList
      className="dx-swatch-catetory-chooser-compact commontreelist"
      id={treeId}
      height={drawerHeight}
      dataSource={theTreedata}
      dataStructure="plain"
      rootValue={null}
      keyExpr={"id"}
      parentIdExpr={"parentId"}
      hasItemsExpr={"ptlHasItems"}
      loadPanel={{ enabled: false }}
      selectedRowKeys={nodeId}
      noDataText={""}
      showColumnLines={false}
      showColumnHeaders={false}
      onSelectionChanged={treeSelectionChanged}
    >
      <Selection mode="single" />
      <SearchPanel visible={true} />
      <Scrolling mode="standard" />

      <Toolbar>
        <Item name="searchPanel" location="before" />
        <Item
          location="after"
          widget="dxButton"
          options={{
            visible: false, // at su not here ...
            elementAttr: { id: "treeViewFilterActive" },
            stylingMode: "text",
            id: "treeViewFilterActive",
            icon: viewInactives ? "eyeopen" : "eyeclose",
            hint: viewInactives ? "Ascunde inactive" : "Arata inactive",
            onClick: onFilterLocal,
            ...customAddOptions,
          }}
        />
        <Item
          // name="customAdd"
          location="after"
          widget="dxButton"
          options={{
            elementAttr: { id: "grdLayoutButton" },
            stylingMode: "text",
            id: "grdLayoutButton",
            icon: "add",
            hint: "Adaugare",
            onClick: onAdd,
            ...customAddOptions,
          }}
        />
      </Toolbar>
      <Column
        dataField={"ptlTitle"}
        caption={""}
        allowSorting={false}
        cellRender={cellRender}
        sortIndex={1}
        sortOrder={"asc"}
      />
      <Column
        dataField={"ptlSortPosition"}
        sortIndex={0}
        sortOrder={"asc"}
        visible={false}
      />
      <Column
        dataField={"ptlDetail"}
        caption={""}
        allowSorting={false}
        visible={false}
      />
    </TreeList>
  );
};
